<template>
    <router-link
        v-slot="{ navigate }"
        :to="{ name: 'Feedback' }"
        custom
    >
        <button
            class="button--accent"
            role="link"
            @click="navigate"
            @keypress.enter="navigate"
        >
            {{ $t('faq.contactUs') }}
        </button>
    </router-link>
</template>

<script>
export default {
    name: 'FAQFeedbackButton'
}
</script>
